import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import isUndefined from 'lodash/isUndefined';
import { withTranslation } from 'react-i18next';
import { Radio } from 'shared/components';

import './PolarQuestion.scss';

class PolarQuestion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      option: props.question.initial,
      idNo: uniqueId('pq-no-'),
      idYes: uniqueId('pq-yes-'),
      yesValue: props.question.yesLabel || this.props.t('common.labels.yes'),
      noValue: props.question.noLabel || this.props.t('common.labels.no'),
    };
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!isUndefined(this.props.value) && prevProps.value !== this.props.value) {
      this.setState({
        option: this.props.value,
      });
    }
  }

  handleOptionChange(e) {
    this.setState({
      option: e.target.value,
    });
    this.props.onChange(this.props.question, e.target.value);
  }

  render() {
    const { errors, disabled } = this.props;
    const error = errors.length ? errors[0] : '';

    return (
      <div className={`polar-question mb-2 ${this.props.className} ${disabled ? 'disabled' : ''}`}>
        <h6 className="fw-bold">{this.props.t(this.props.question.title)}</h6>
        {error && (
          <p className="text-error font-size-12" key={error}>
            {this.props.t(error)}
          </p>
        )}
        {this.state.option === this.state.noValue && this.props.question.subtitleNo && (
          <p className="font-size-12 question-message">
            {this.props.t(this.props.question.subtitleNo)}
          </p>
        )}
        <div className="form-check form-check-inline mr-3">
          <Radio
            value={this.state.yesValue}
            label={this.state.yesValue}
            checked={this.state.option === this.state.yesValue}
            disabled={disabled}
            onChange={this.handleOptionChange}
          />
        </div>
        <div className="form-check form-check-inline">
          <Radio
            value={this.state.noValue}
            label={this.state.noValue}
            checked={this.state.option === this.state.noValue}
            disabled={disabled}
            onChange={this.handleOptionChange}
          />
        </div>
      </div>
    );
  }
}

PolarQuestion.propTypes = {
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitleNo: PropTypes.string,
    initial: PropTypes.string,
    yesLabel: PropTypes.string,
    noLabel: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  value: PropTypes.string,
  t: PropTypes.func.isRequired,
};

PolarQuestion.defaultProps = {
  className: '',
  errors: [],
  disabled: false,
};

export default withTranslation()(PolarQuestion);
